import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper
} from '@mui/material';
import MainCard from '../../components/MainCard';
import Sidebar from "../../menu-items/Sidebar";
import axios from 'axios';
import Cookies from "js-cookie";
import { Backdrop, CircularProgress } from '@mui/material';

const UserLogins = () => {
    const [data, setData] = useState([]); 
  const [page, setPage] = useState(0);                  
  const [rowsPerPage, setRowsPerPage] = useState(50);   
  const [totalCount, setTotalCount] = useState(0);
  const [exporting, setExporting] = useState(false);      




  const fetchData = async () => {
    try {
      const token = axios.defaults.headers.common.Authorization;
      const baseUrl = process.env.REACT_APP_BASE_URL;

      // Backend expects 1-based "offset" page like your Waitlist
      const params = new URLSearchParams({
        limit: rowsPerPage.toString(),
        offset: (page + 1).toString()
      });

      const url = `${baseUrl}admin/reports/user_logins?${params.toString()}`;

      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const response = await axios.get(url, config);

      // Normalize payload: prefer { results, total }, but fall back smartly
      const payload = response?.data;
      const results = Array.isArray(payload?.results)
        ? payload.results
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
        ? payload
        : Object.values(payload ?? {});

      const total =
        typeof payload?.total === 'number'
          ? payload.total
          : Array.isArray(payload?.results)
          ? payload.results.length
          : Array.isArray(payload?.data)
          ? payload.data.length
          : Array.isArray(payload)
          ? payload.length
          : results.length;

      setData(results);
      setTotalCount(total);
    } catch (error) {
      console.error('Error fetching user logins:', error);
      setData([]);
      setTotalCount(0);
    }
  };

  // fetch on first load + whenever page/rowsPerPage change
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const downloadAllAsCSV = async () => {
  setExporting(true);
  try {
    // --- helpers from previous step ---
    const normalizePayload = (payload: any) => {
      const results = Array.isArray(payload?.results)
        ? payload.results
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
        ? payload
        : Object.values(payload ?? {});
      const total =
        typeof payload?.total === 'number'
          ? payload.total
          : Array.isArray(payload?.results)
          ? payload.results.length
          : Array.isArray(payload?.data)
          ? payload.data.length
          : Array.isArray(payload)
          ? payload.length
          : results.length;
      return { results, total };
    };

    const fetchPage = async (pageIndex1Based: number, limit: number) => {
      const token = axios.defaults.headers.common.Authorization;
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const params = new URLSearchParams({
        limit: String(limit),
        offset: String(pageIndex1Based),
      });
      const url = `${baseUrl}admin/reports/user_logins?${params.toString()}`;
      const config = { headers: { Authorization: `${token}` } };
      const res = await axios.get(url, config);
      return normalizePayload(res.data);
    };

    // --- export all pages ---
    const pageSize = 500; // tweak if needed (must be <= backend cap)
    const first = await fetchPage(1, pageSize);
    const allRows: any[] = [...first.results];
    const total = first.total;
    const totalPages = Math.ceil(total / pageSize);

    for (let p = 2; p <= totalPages; p++) {
      const { results } = await fetchPage(p, pageSize);
      allRows.push(...results);
    }

    // build CSV
    const headers = ['#', 'Event ID', 'Event', 'Description', 'Practice', 'User ID', 'Role', 'Timestamp'];
    const csvRows: string[] = [headers.join(',')];

    allRows.forEach((row: any, idx: number) => {
      const cells = [
        (idx + 1).toString(),
        row?.['event id'] ?? '',
        row?.event ?? '',
        row?.description ?? '',
        row?.practice ?? '',
        row?.['user id'] ?? '',
        row?.role ?? '',
        row?.timestamp ?? '',
      ].map(v =>
        typeof v === 'string' && (v.includes(',') || v.includes('"'))
          ? `"${v.replace(/"/g, '""')}"`
          : v
      );
      csvRows.push(cells.join(','));
    });

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'user_logins_all.csv';
    link.click();
  } catch (err) {
    console.error('Download all CSV failed:', err);
  } finally {
    setExporting(false);
  }
};

  return (
    <Box sx={{ border: '1px solid #ccc', padding: 5, height: '100vh' }}>
      <Grid container rowSpacing={2.5} columnSpacing={2.75}>
        <Grid item xs={12} md={3} lg={2}>
          <Sidebar />
        </Grid>

        <Grid item xs={12} md={9} lg={10}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 'bold',
                fontSize: '2rem',
              }}
            >
              User Login Data
            </Typography>
        <Button
  variant="contained"
  color="primary"
  sx={{ marginLeft: 2 }}
  onClick={downloadAllAsCSV}
  disabled={exporting}
  startIcon={exporting ? <CircularProgress size={18} /> : null}
>
  {exporting ? 'Preparing CSV…' : 'Download ALL as CSV'}
</Button>

<Backdrop
  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={exporting}
>
  <CircularProgress />
</Backdrop>
          </Box>

          <MainCard title="">
            {/* Top pagination (like Waitlist) */}
            <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

            <TableContainer
              component={Paper}
              sx={{
                borderRadius: '15px',
                boxShadow: 3,
                overflow: 'hidden',
                marginTop: 2,
              }}
            >
              <Table sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#1976d2', color: '#fff' }}>
                    <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Event ID</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Event</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Practice</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>User ID</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Role</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Timestamp</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {data.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    data.map((row: any, index: number) => (
                      <TableRow
                        key={`${row?.['event id'] ?? 'row'}-${index}`}
                        sx={{
                          '&:hover': {
                            backgroundColor: '#f5f5f5',
                            cursor: 'pointer',
                          },
                          borderBottom: '1px solid #ddd',
                        }}
                      >
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>{row?.['event id']}</TableCell>
                        <TableCell>{row?.event}</TableCell>
                        <TableCell>{row?.description}</TableCell>
                        <TableCell>{row?.practice}</TableCell>
                        <TableCell>{row?.['user id']}</TableCell>
                        <TableCell>{row?.role}</TableCell>
                        <TableCell>{row?.timestamp}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Bottom pagination (like Waitlist) */}
            <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </MainCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserLogins;
